import { z } from 'zod';

export const MonitorIntervalTypeSchema = z.enum(['weekly', 'monthly', 'quarterly', 'yearly']);

export type MonitorInterval = z.infer<typeof MonitorIntervalTypeSchema>;
